<template>
    <a class="iconbutton"   @click="$emit('click')" :disabled="disabled">
        <img alt="remove image" src="@/assets/remove.png"  class="iconimage" >
    </a>
</template>

<script>
export default {
    name:'removebutton',
    props:{
        
        disabled:{
          type:Boolean,
          default:false
        }
    },
    data() {
        return {
            
        };
    },
}
</script>

<style scoped>

.iconbutton:hover{
    
    cursor:pointer;
}

.iconimage{
    width:17px;
}
</style>